module.exports = __webpack_public_path__ + "img/guest_profile.f552a91f.jpg";